import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './mentions-legales.component.html',
  styleUrl: './mentions-legales.component.css'
})
export class MentionsLegalesComponent implements OnInit {

  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Mentions Légales — Mesh Box : Agence de Développement Web");
    this.metaService.updateTag({ name: 'description', content: "Retrouvez les mentions légales de l'agence Mesh Box. Informations sur l'éditeur, l'hébergement et la propriété intellectuelle du site www.mesh-box.fr." });
  }
}